import i18next from 'i18next';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useAppSettings } from '../settings/providers/AppSettingsProvider';
import useAppFormatAmount from './hooks/useAppFormatAmount';
import getSymbolFromCurrency from 'currency-symbol-map';
import { TInvestFundCurrency } from '../../../apps/investor/types/fund/TInvestFundCurrency';

type AppFormatAmountProps = {
	currency: TInvestFundCurrency;
	value?: number;
	textIfNull?: string;
	addSpace?: boolean;
	customFloatDigitLimit?: number;
	disableIntegerRounding?: boolean;
};

const AppFormatAmount = (props: AppFormatAmountProps) => {
	const { value, addSpace, textIfNull, currency, customFloatDigitLimit, disableIntegerRounding } = props;

	const { rounding } = useAppSettings();

	const { displayRounding, displayRoundingSuffix } = useAppFormatAmount();

	const [minimumFractionDigits, setMinimumFractionDigits] = useState(2);

	// // On détermine que si la longueur du nombre avant la virgule fait + de 4 digits, on arrondi pas si ce n'est pas nécessaire
	useEffect(() => {
		if (rounding && value) {
			if (_.round(displayRounding(value === 0 ? 0 : value, rounding), 0).toString().length >= 4) {
				setMinimumFractionDigits(0);
			} else {
				setMinimumFractionDigits(2);
			}
		}
	}, [customFloatDigitLimit, displayRounding, rounding, value]);

	let formattedValue = disableIntegerRounding ? value : displayRounding(value === 0 ? 0 : value ?? 0, rounding);
	if (customFloatDigitLimit && disableIntegerRounding) {
		formattedValue = _.round(value ?? 0, customFloatDigitLimit);
	}

	return (
		<>
			{currency === null ? (
				'M/C'
			) : (
				<>
					{value === undefined ? (
						<>...</>
					) : value === null ? (
						<>{textIfNull ?? '0'}</>
					) : (
						<>
							{(formattedValue ?? 0).toLocaleString(i18next.language, {
								minimumFractionDigits: minimumFractionDigits,
								maximumFractionDigits: customFloatDigitLimit ?? 9,
							})}

							{addSpace ? ' ' : ''}
							{!disableIntegerRounding && displayRoundingSuffix(rounding)}
							{currency ? getSymbolFromCurrency(currency) : getSymbolFromCurrency('EUR')}
						</>
					)}
				</>
			)}
		</>
	);
};

export default AppFormatAmount;
